import { render, staticRenderFns } from "./ImgCaptcha.vue?vue&type=template&id=234ee5f9&scoped=true&"
import script from "./ImgCaptcha.vue?vue&type=script&lang=js&"
export * from "./ImgCaptcha.vue?vue&type=script&lang=js&"
import style0 from "./ImgCaptcha.vue?vue&type=style&index=0&id=234ee5f9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "234ee5f9",
  null
  
)

export default component.exports